import { motion } from "framer-motion";
import { useApp } from "@/context/AppContext";
import { T } from "@/i18n/translations";

export const Manifesto = () => {
  const { t, lang } = useApp();
  const chapters = T.why;

  return (
    <section id="why" className="scroll-mt-24 bg-petrol py-24 lg:py-32">
      <div className="grain absolute inset-0 opacity-30" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <p className="overline mb-16 text-gold">{t("sections.why_over")}</p>
        <div className="flex flex-col gap-16">
          {chapters.map((c, i) => {
            const item = c[lang] || c.en;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="grid grid-cols-1 gap-6 border-t border-white/15 pt-10 md:grid-cols-12"
              >
                <div className="md:col-span-2">
                  <span className="font-serif text-5xl italic text-terracotta">0{i + 1}</span>
                </div>
                <h3 className="font-serif text-3xl font-medium leading-tight text-sand md:col-span-6 lg:text-4xl">
                  {item.t}
                </h3>
                <p className="text-base leading-relaxed text-white/70 md:col-span-4">{item.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
